// @flow
import React from 'react';
import ReportsEdit from './ReportsEdit';

const ReportsList = () => <ReportsEdit />;

export default ReportsList;
